export const validate = values => 
{
    const errors = {}

    if (!values.bulkuploadfilename) {
        errors.bulkuploadfilename = 'File cannot be left blank.!'
    } 
  return errors
}